<template>
  <div :id="id" class="catalog">
    <div class="catalog__top">
      <div class="componata-container">
        <FancyHeading class="catalog__heading">
          <template v-slot:title><span v-html="content.title"></span></template>
          <template v-slot:description>{{ content.description }}</template>
        </FancyHeading>

        <Tabs
          v-if="navigationTabs.length > 1"
          :data="navigationTabs"
          @change="showTabContent($event)"
          class="catalog__tabs"
        />
      </div>
    </div>

    <div class="catalog__bottom">
      <div class="catalog__content-area">
        <div class="componata-container">
          <div
            v-for="(item, index) in content.sections"
            :key="index"
            class="catalog__content-section-wrapper"
            :class="{ '--is-visible' : activeContentIndex === index }"
          >
            <section class="catalog__content-section">
              <ul
                v-if="presents.length > 0"
                class="catalog__present-list"
              >
                <li
                  v-for="present in presents.filter(b => item.presents.includes(b.id))"
                  :key="present.id"
                  class="catalog__present"
                >
                  <ProductCard :item="present" />
                </li>

                <li class="catalog__present">
                  <div class="catalog__more-card">
                    <h4>Größere Auswahl gewünscht?</h4>
                    <p>Unser Gesamtsortiment umfasst derzeit mehr als 30 fertige Präsentboxen.</p>
                    <router-link :to="cLink('/fertige')">Alle fertigen Präsente anzeigen <i class="icon icon-angle-right"></i></router-link>
                  </div>
                </li>
              </ul>

              <ul v-else class="catalog__present-list">
                <li
                  v-for="index in 7"
                  :key="index"
                  class="catalog__present"
                >
                  <ProductCard :isLoaded="false" />
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import { logicMixin } from '@/mixins/LogicMixin';

import FancyHeading from '@/components/Pages/FancyHeading';
import Tabs from '@/components/Pages/Tabs';
import ProductCard from '@/components/Configurator/ProductCard';

export default {
  name: 'Catalog',
  mixins: [logicMixin],
  components: {
    FancyHeading,
    Tabs,
    ProductCard
  },
  props: {
    id: {
      type: String,
      default: 'catalog'
    },
    content: {
      type: Object
    }
  },
  data () {
    return {
      navigationTabs: [],
      activeContentIndex: 0,
      presents: [],
    };
  },
  methods: {
    showTabContent ($event) {
      this.activeContentIndex = $event;
    }
  },
  created () {
    // Create navigation tabs object based on the content
    this.content.sections.forEach(item => {
      this.navigationTabs.push({
        icon: item.tab_icon,
        title: item.tab_title
      });
    });

    var ids = [];

    this.content.sections.forEach(s => {
      ids = [...ids, ...s.presents];
    });

    axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_level_1_fast?selectedId=' + ids.join()).then((response) => {
      this.presents = this.extendLvl1Req(response.data);
    });

    this.$store.commit('setCurrentLevel', 1);
    this.doReplace();
  },
  mounted () {
  },
  updated () {
    this.$nextTick(() => {
      this.$root.$emit('AOSRefresh');
    });
  }
};
</script>

<style lang="scss" scoped>
/**
 * Catalog
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Content section for showcasing presents by certain categories
 * @since 2022-07-04
**/

$component: 'catalog';

.#{$component} {
  &__top {
    position: relative;
    overflow: hidden;
    z-index: 0;
    @include padding-top(map-get($spacers, 6) * 2);
    padding-bottom: 2px;
    background: linear-gradient(to bottom, #C4E8FC, #FFF);
  }

  &__heading {
    --from: #241B1F;
    --to: #FF6F6F;
    --shadow: #ffffff01;

    width: 60%;
    margin: 0 auto;
    @include margin(0 auto (map-get($spacers, 5) * 2) auto);
    text-align: center;
  }

  &__tabs {
    --color-active: #FF6F6F;

    // @include margin-bottom(map-get($spacers, 6));
  }

  &__bottom {
    @include padding(map-get($spacers, 4) 0);
    background: $white;
    color: $ink;
  }

  &__content-area {
    transition: all 0.3s ease-in-out;
  }

  &__content-section-wrapper {
    display: none;

    &.--is-visible {
      display: block;
    }
  }

  &__content-section {
    width: 100%;
    animation: content-in 0.5s ease-in-out forwards;

    @keyframes content-in {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }
  }

  &__present-list {
    @include unlist;
    display: flex;
    flex-wrap: wrap;
    margin: 0;
  }

  &__present {
    flex-basis: 30%;

    &:not(:nth-of-type(3n)) {
      margin-right: 4%;
      @include margin-bottom(map-get($spacers, 6));
    }

    ::v-deep .product-card {
      &__photo-wrapper {
        @include padding(map-get($spacers, 3));
        border: none;
      }

      @include hover () {
        background: transparent;
        outline: none;
      }
    }
  }

  &__more-card {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 300px;
    height: 100%;
    border-radius: $border-radius-lg;
    @include padding(map-get($spacers, 3));
    box-shadow: 6px 6px 14px rgba(0, 0, 0, 0.05);

    p {
      color: $ink-light;
      font-weight: $font-weight-light;
    }

    a {
      display: flex;
      align-content: center;

      .icon {
        @include font-size(map-get($lp, 'font-size-lg') * 1.3);
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-md')) {
    &__heading {
      width: 70%;
    }

    &__present {
      flex-basis: 30%;

      &:not(:nth-of-type(4n)) {
        margin-right: 0;
      }

      &:not(:nth-of-type(3n)) {
        margin-right: 3.3%;
      }
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-sm')) {
    &__heading {
      width: 80%;
    }

    &__present {
      flex-basis: 46%;

      &:not(:nth-of-type(4n)) {
        margin-right: 0;
      }

      &:not(:nth-of-type(3n)) {
        margin-right: 0;
      }

      &:not(:nth-of-type(2n)) {
        margin-right: 8%;
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-xs')) {
    &__heading {
      width: 90%;
    }

    &__present {
      flex-basis: 90%;
      margin-left: auto;
      margin-right: auto !important;
    }
  }
}
</style>
